export function fmtWeight(w) {
  if (!w) return "";
  const s = String(w).trim();
  return /kg/i.test(s) ? s : `${s} kg`;
}

export function PatientDetails({ b, testid }) {
  return (
    <div className="text-sm text-[#64748B] space-y-0.5 mt-1" data-testid={testid || `patient-details-${b.id}`}>
      <p><span className="font-semibold text-[#373E45]">Paciente:</span> {b.patient_name}</p>
      {b.owner_name && <p><span className="font-semibold text-[#373E45]">Propietario:</span> {b.owner_name}</p>}
      <p>
        <span className="font-semibold text-[#373E45]">Especie:</span> {b.species}
        {b.age ? <> · <span className="font-semibold text-[#373E45]">Edad:</span> {b.age}</> : null}
        {b.weight ? <> · <span className="font-semibold text-[#373E45]">Peso:</span> {fmtWeight(b.weight)}</> : null}
      </p>
      <p><span className="font-semibold text-[#373E45]">Exploración:</span> {b.study_type}</p>
      {b.reason && <p><span className="font-semibold text-[#373E45]">Motivo / sospecha clínica:</span> {b.reason}</p>}
      {b.notes && <p><span className="font-semibold text-[#373E45]">Comentarios:</span> {b.notes}</p>}
    </div>
  );
}
